import { Flex, Text } from "@radix-ui/themes";
import { useEffect } from "react";
import LoadingIndicator from "../../shared/LoadingIndicator";

interface Props {
    userEmail?: string;
}

export default function DeviceVerificationFlow({ userEmail }: Props) {
    useEffect(() => {
        console.log("🌍 [AUTH] Device Verification Flow - Redirecting to Add Device");
        const mcpUrl = import.meta.env.VITE_MCP_URL || window.location.origin;
        // Redirect to the main app's add-device page
        const redirectUrl = `${mcpUrl}/verify-device${window.location.search}`;
        window.location.href = redirectUrl;
    }, []);

    return (
        <Flex
            align="center"
            justify="center"
            style={{
                height: "100vh",
            }}
            direction="column"
            gap="4"
        >
            <LoadingIndicator />
            <Text>Verifying device...</Text>
            {userEmail && (
                <Text size="2" color="gray">
                    Logged in as {userEmail}
                </Text>
            )}
        </Flex>
    );
}
